<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2024-12-09 11:12:05
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2025-08-12 09:28:16
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/nesting/components/addCreditDrawer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div>
    <div class="notice-content">
      <p class="">填写说明：</p>
      <p>
        <span> 1.以下信息均为必填项，请全部填写完成后提交； </span>
        <span
          >2.若供应商上传的企业审计报告不正确，请线下联系供应商进行更新，完成审计报告确认后，方可提交。</span
        >
        <span>3.财务数据年度应选择评价报告财务信息对应年度。</span>
      </p>
    </div>
    <div class="form-content">
      <p class="title">企业信用评价结果</p>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="供应商：" prop="companyName">
              <el-autocomplete
                v-model="ruleForm.companyName"
                class="inline-input"
                :fetch-suggestions="querySearch"
                placeholder="请输入供应商名称"
                :trigger-on-focus="false"
                style="width: 250px"
                @select="handleSelect"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书编号：" prop="certificateNo">
              <el-input
                v-model="ruleForm.certificateNo"
                placeholder="请输入证书编号"
                style="width: 250px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="有效期至：" prop="certificateEffectiveEndTime">
              <div class="flex">
                <el-date-picker
                  v-model="ruleForm.certificateEffectiveEndTime"
                  style="width: 250px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择日期"
                >
                </el-date-picker>
                <el-checkbox
                  v-model="longTermEffective"
                  style="margin-left: 10px"
                  >长期有效</el-checkbox
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="评价等级：" prop="evaluationLevel">
              <el-select
                v-model="ruleForm.evaluationLevel"
                placeholder="请选择评价等级"
                style="width: 250px"
              >
                <el-option
                  v-for="item in evaluationLevelOptions"
                  :key="item.label"
                  :value="item.label"
                  >{{ item.label }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="验证网址：" prop="checkWebSite">
              <el-input
                v-model="ruleForm.checkWebSite"
                placeholder="请输入验证网址"
                style="width: 250px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="证书附件：" prop="certificateFile">
              <el-upload
                class="upload-demo"
                :action="action"
                :on-remove="handleRemoveCertificateFile"
                :limit="1"
                :file-list="fileList"
                :headers="headers"
                :on-success="handleCertificateImgSuccess"
                :before-upload="handleBeforeUpload"
              >
                <eui-btn
                  style="flex-shrink: 0"
                  type="secondary"
                  icon-position="left"
                  icon="eicon-upload"
                  >上传文件</eui-btn
                >
                <div slot="tip" class="el-upload__tip">
                  <eui-tooltip content="公开询价内容：" placement="top" s>
                    <div slot="content">
                      <p>1.若附件为多页，请上传PDF 格式的文件；</p>
                      <p>2.文件大小不超过20MB；</p>
                      <p>3.文件格式为JPG，JPEG， PNG，PDF；</p>
                      <p>4.图片尺寸最大为2000*2000 像素，最小为600*600像素。</p>
                    </div>
                    <eui-icon
                      icon="eicon-r-l-changjianwenti"
                      color="#C5C5C5"
                      font-size="20px"
                    />
                  </eui-tooltip>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报告附件：" prop="reportFile">
              <el-upload
                class="upload-demo"
                :headers="headers"
                :action="action"
                :on-remove="handleRemoveReportFile"
                :limit="1"
                :file-list="reportFileList"
                :on-success="handleReportImgSuccess"
              >
                <eui-btn
                  style="flex-shrink: 0"
                  type="secondary"
                  icon-position="left"
                  icon="eicon-upload"
                  >上传文件</eui-btn
                >
                <div slot="tip" class="el-upload__tip">
                  <eui-tooltip content="公开询价内容：" placement="top" s>
                    <div slot="content">
                      <p>1.若附件为多页，请上传PDF 格式的文件；</p>
                      <p>2.文件大小不超过20MB；</p>
                      <p>3.文件格式为JPG，JPEG， PNG，PDF；</p>
                      <p>4.图片尺寸最大为2000*2000 像素，最小为600*600像素。</p>
                    </div>
                    <eui-icon
                      icon="eicon-r-l-changjianwenti"
                      color="#C5C5C5"
                      font-size="20px"
                    />
                  </eui-tooltip>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <p class="title">企业财务数据</p>
      <div>
        <companyData
          ref="companyData"
          :supplier-id="supplierId"
          @handleYearChange="handleYearChange"
        ></companyData>
      </div>
      <p class="title">企业审计报告</p>
      <div class="report-content">
        <auditReport
          :report-list="reportList"
          @handleConfirmReport="handleConfirmReport"
          @handleUpdateReport="handleUpdateReport"
        ></auditReport>
      </div>
    </div>
    <div class="footer-content">
      <div>
        <eui-btn type="secondary" @click="goBack()">取消</eui-btn>
        <eui-btn type="secondary" @click="submitForm(1)">保存</eui-btn>
        <eui-btn :disabled="submitLoading" @click="submitForm(2)">提交</eui-btn>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/user/index';
import auditReport from './auditReport.vue';
import companyData from './companyData.vue';
import { epecToken } from '../../../utils/globalData';

export default {
  components: { auditReport, companyData },
  props: {
    type: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      submitLoading: false,
      action: api.fileUploadForCompanyCreditEvaluation,
      headers: epecToken,
      fileList: [],
      reportFileList: [],
      longTermEffective: false,
      evaluationLevelOptions: [
        { label: 'AAA' },
        { label: 'AA' },
        { label: 'A' },
        { label: 'BBB' },
        { label: 'BB' },
        { label: 'B' },
        { label: 'CCC' },
        { label: 'CC' },
        { label: 'C' },
        { label: 'D' },
      ],
      ruleForm: {
        companyName: '',
        certificateNo: '',
        evaluationLevel: '',
        checkWebSite: '',
        longTermEffective: null,
        certificateFile: '',
        reportFile: '',
        // certificateEffectiveBeginTime: '',
        certificateEffectiveEndTime: '',
        status: '',
        // validDate: '',
      },
      rules: {
        companyName: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' },
        ],
        certificateNo: [
          { required: true, message: '请输入证书编号', trigger: 'blur' },
        ],
        evaluationLevel: [
          {
            required: true,
            message: '请选择评价等级',
            trigger: 'blur',
          },
        ],
        checkWebSite: [
          {
            required: true,
            message: '请输入验证网址',
            trigger: 'blur',
          },
        ],
        reportFile: [
          {
            required: true,
            message: '请上传报告附件',
            trigger: 'change',
          },
        ],
        certificateFile: [
          {
            required: true,
            message: '请上传证书附件',
            trigger: 'change',
          },
        ],
      },
      reportList: [],
      creditEvaluationDetail: {},
      financeList: [
        {
          assetLiabilityRatio: '',
          currentAssets: '',
          currentAssetsNetValue: '',
          currentLiabilities: '',
          currentRatio: '',
          externalGuaranteeAmount: '',
          fixedAssetsNetValue: '',
          fixedAssetsOriginalValue: '',
          netProfit: '',
          operatingMargin: '',
          operatingRevenue: '',
          profitMargin: '',
          totalAssets: '',
          totalLiabilities: '',
          year: '2019',
        },
      ],
      supplierId: '',
      confirmList: [], // 报告确认后存储的数据
    };
  },

  computed: {},
  watch: {
    // type: {
    //   handler(val, oldVal) {
    //     debugger;
    //     if (val === 'EDIT') {
    //       this.getCreditEvaluationDetail();
    //       this.$refs.companyData.editInitData(
    //         this.creditEvaluationDetail.financeList
    //       );
    //     } else {
    //       this.$refs.companyData.editInitData(this.financeList);
    //       for (const key in this.ruleForm) {
    //         this.ruleForm[key] = '';
    //       }
    //       this.fileList = [];
    //       this.reportFileList = [];
    //     }
    //   },
    //   deep: true,
    // },
  },
  created() {
    // if (this.type === 'EDIT') {
    //   this.getCreditEvaluationDetail();
    //   this.$refs.companyData.editInitData(
    //     this.creditEvaluationDetail.financeList
    //   );
    // }
  },
  async mounted() {
    console.log('mounted');
    if (this.type === 'EDIT') {
      await this.getCreditEvaluationDetail();
      this.$refs.companyData.editInitData(
        this.creditEvaluationDetail.financeList
      );
    } else {
      this.$refs.companyData.editInitData(this.financeList);
      // this.reportList = [];
      for (const key in this.ruleForm) {
        this.ruleForm[key] = '';
      }
      this.fileList = [];
      this.reportFileList = [];
    }
  },
  methods: {
    // 获取企业评价详情
    async getCreditEvaluationDetail() {
      console.log(this.id);
      const res = await api.queryCompanyCreditEvaluationDetail({
        creditEvaluationId: this.id,
      });

      if (res.code === '200') {
        this.creditEvaluationDetail = res.data;
        this.supplierId =
          this.creditEvaluationDetail.companyCreditEvaluationAO.companyId;
        this.ruleForm = res.data.companyCreditEvaluationAO;
        this.ruleForm.creditEvaluationId = this.id;
        const { companyCreditEvaluationAO } = res.data;
        // this.ruleForm.validDate = [
        //   companyCreditEvaluationAO.certificateEffectiveBeginTime,
        //   companyCreditEvaluationAO.certificateEffectiveEndTime,
        // ];
        this.longTermEffective = this.ruleForm.longTermEffective === 1;
        this.reportList = res.data.corporateAuditReportList;
        this.formatFormData(companyCreditEvaluationAO);
      }
    },
    // 组装回显表单数据
    formatFormData(obj) {
      // fileList: [],
      // reportFileList: [],
      this.fileList = [
        {
          name: obj.certificateFileName,
          url: obj.certificateFile,
        },
      ];
      this.reportFileList = [
        {
          name: obj.reportFileName,
          url: obj.reportFile,
        },
      ];
    },
    async querySearch(queryString, cb) {
      const res = await api.querySupplierByName({ companyName: queryString });
      if (res.code === '200') {
        const companyList = res.data.map((item) => {
          return {
            value: item.companyName,
            id: item.companyId,
          };
        });
        cb(companyList);
      }
      // var restaurants = this.restaurants;
      // var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      // cb(results);
    },
    async handleSelect(item) {
      this.ruleForm.companyId = item.id;
      this.supplierId = item.id;
      const yearsList = this.$refs.companyData.getYearsList();
      await this.getReportList(yearsList);
    },
    submitForm(type) {
      const companyListData = this.$refs.companyData.getData();

      this.ruleForm.certificateFile =
        this.fileList.length > 0 ? this.fileList[0].url : '';
      this.ruleForm.reportFile =
        this.reportFileList.length > 0 ? this.reportFileList[0].url : '';
      this.ruleForm.certificateFileName =
        this.fileList.length > 0 ? this.fileList[0].name : '';
      this.ruleForm.reportFileName =
        this.reportFileList.length > 0 ? this.reportFileList[0].name : '';
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          console.log(this.checkCompanyData(companyListData));
          const companyListDataEmpty = this.checkCompanyData(companyListData);
          if (companyListDataEmpty && type !== 1) {
            this.$message.error('请填写企业财务数据');
            return false;
          }
          this.ruleForm.longTermEffective = this.longTermEffective ? 1 : '';
          // const [startTime, endTime] = this.ruleForm.validDate;
          // this.ruleForm.certificateEffectiveBeginTime = startTime;
          // this.ruleForm.certificateEffectiveEndTime = endTime;
          // this.ruleForm.confirmList = this.confirmList;
          this.ruleForm.status = type; // 1保存，2提交

          const params = {
            companyCreditEvaluationAO: this.ruleForm,
            financeList: companyListData,
            confirmList: this.confirmList,
          };
          console.log(params, 'params');
          const url =
            this.type === 'EDIT'
              ? 'modifyCompanyCreditEvaluation'
              : 'addCompanyCreditEvaluation';
          const res = await api[url](params);
          if (res.code === '200') {
            this.$message({
              message: '操作成功',
              type: 'success',
            });
            this.$emit('close');
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 判断报告是否为空
    checkCompanyData(list) {
      let flag = false;
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        Object.keys(item).some((key) => {
          if (item[key] === '' || item[key] === null) {
            flag = true;
            return true; // 退出 some 循环
          }
          return false;
        });
        if (flag) break;
      }
      return flag;
    },
    // 确认报告
    async handleConfirmReport(options) {
      console.log(options);
      // 判断是否已经确认过
      const flag = this.confirmList.some((item) => {
        return item.auditReportId === options.id;
      });
      if (flag) {
        this.$message.warning('报告已确认过');
        return;
      }
      this.confirmList.push({ auditReportId: options.id });
      let confirmIndex = null;
      this.reportList.forEach((item, index) => {
        if (item.auditReportId === options.id) {
          // item.status = 2;
          confirmIndex = index;
        }
      });
      this.$set(this.reportList[confirmIndex], 'status', 2);
      console.log(this.reportList, 'this.reportList');
      // const res = await api.confirmAuditReport({ auditReportId: options.id });
      // if (res.code === '200') {
      //   const yearsList = this.$refs.companyData.getYearsList();
      //   this.reportList = [];
      //   await this.getReportList(yearsList);
      // }
    },
    // 更新报告
    async handleUpdateReport(options) {
      console.log(options);
      const res = await api.updateAuditReport({
        auditReportId: options.id,
        // status: 2,
      });
      if (res.code === '200') {
        if (Number(res.data.result) === 1) {
          this.$message.success('审计报告更新成功！');
          this.reportList = res.data.corporateAuditReportVO;
        } else if (Number(res.data.result) === 2) {
          this.$message.success('审计报告更新成功！');
        } else if (Number(res.data.result) === 3) {
          this.$message.error('审计报告获取失败，请重新更新！');
        }
      }
    },
    handleRemoveCertificateFile() {
      this.fileList = [];
    },
    handleRemoveReportFile() {
      this.reportFileList = [];
    },
    handleCertificateImgSuccess(response) {
      this.fileList.push({
        url: response.data.url,
        name: response.data.fileName,
      });
    },
    handleReportImgSuccess(response, file, fileList) {
      this.reportFileList.push({
        url: response.data.url,
        name: response.data.fileName,
      });
    },
    handleBeforeUpload(file) {
      console.log(file);
      if (
        file.type !== 'image/png' &&
        file.type !== 'image/jpg' &&
        file.type !== 'image/jpeg' &&
        file.type !== 'application/pdf'
      ) {
        this.$message.warning('文件为JPG、JPEG、PNG格式');
        return false;
      }
      const size = file.size / 1024 / 1024;
      if (size > 20) {
        this.$message.warning('图片不能超过20M');
        return false;
      }
      return true;
      // const { length } = this.detailImgList;
      // if (length >= 10) {
      //   this.$message.warning('介绍图的图片数量不能超过10张');
      //   return false;
      // }
    },
    // 获取审计报告
    async getReportList(yearsList) {
      yearsList.forEach(async (item) => {
        const params = {
          companyId: this.ruleForm.companyId,
          year: Number(item.value),
        };
        const res = await api.queryAuditReportByYear(params);
        if (res.code === '200' && res.data !== undefined) {
          this.reportList.push(res.data);
        }
      });
    },
    handleYearChange(options) {
      console.log(options, 'options');
      this.reportList = [];
      this.getReportList(options);
    },
    goBack() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.notice-content {
  display: flex;
  flex-flow: row;
  background: #e8efff;
  padding: 15px 10px;
  p:first-child {
    color: $headline-color-num;
    font-size: 14px;
    font-weight: 700;
    flex-shrink: 0;
  }
  p:last-child {
    display: flex;
    flex-flow: column;
    color: $font-color-text;
    font-size: 14px;
    // margin-left: 10px;
  }
}
.form-content {
  .title {
    color: $font-color-text;
    font-size: 14px;
    // line-height: 24px;
    font-weight: 500;
    margin-bottom: 20px;
    margin-top: 20px;
  }
}
.upload-demo {
  // display: flex;
  // align-items: center;
}
.el-upload__tip {
  margin-left: 10px;
  display: inline-block;
  /* margin-top: 15px; */
  position: absolute;
  top: -3px;
}
.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-top: 20px; */
  /* margin-bottom: 20px; */
  position: fixed;
  bottom: 0;
  width: 800px;
  background: #fff;
  text-align: center;
  padding-bottom: 20px;
  z-index: 100;
}
.report-content {
  margin-bottom: 70px;
}
::v-deep .el-range-editor--small .el-range-separator {
  width: 22px;
}
::v-deep .el-checkbox__label {
  font-weight: normal;
}
</style>
